import { SET_MODAL_OPTIONS as o, SET_MODAL_PRIMARY_BTN_DISABLED as n, SHOW_MODAL as e, HIDE_MODAL as r } from "./types.js";
function i(t) {
  return {
    type: o,
    payload: t
  };
}
function p(t) {
  return {
    type: n,
    payload: t
  };
}
function M() {
  return {
    type: e
  };
}
function d() {
  return {
    type: r
  };
}
export {
  d as hideModal,
  i as setModalOptions,
  p as setModalPrimaryBtnDisabled,
  M as showModal
};
//# sourceMappingURL=actions.js.map
